/**
 * 폴더 선택 모달
 * 노트를 다른 폴더로 이동할 때 사용
 */

import React, { useState } from 'react';
import { useFolders } from '../../contexts/FolderContext';
import {
  FolderOpen,
  Folder,
  Star,
  Clock,
  Archive,
  Trash2,
  BookOpen,
  Briefcase,
  Heart,
  Shield,
  Code,
  Music,
  Camera,
  MapPin,
  ShoppingBag,
  Users,
  Home,
  FileText,
  X,
  Check
} from 'lucide-react';
import { Button } from '../UI';
import './SecureNotes.css';

function FolderSelectModal({ isOpen, onClose, onSelect, currentFolderId, noteTitle }) {
  const { folderTree, SYSTEM_FOLDERS } = useFolders();
  const [selectedFolder, setSelectedFolder] = useState(null);

  if (!isOpen) return null;

  // 아이콘 렌더링
  const renderFolderIcon = (folder) => {
    const IconComponent = {
      folder: Folder,
      star: Star,
      clock: Clock,
      archive: Archive,
      trash: Trash2,
      book: BookOpen,
      briefcase: Briefcase,
      heart: Heart,
      shield: Shield,
      code: Code,
      music: Music,
      camera: Camera,
      map: MapPin,
      shopping: ShoppingBag,
      users: Users,
      home: Home,
      file: FileText
    }[folder.icon] || Folder;

    return <IconComponent size={20} style={{ color: folder.color }} />;
  };

  // 폴더 선택 처리
  const handleSelect = () => {
    if (selectedFolder && selectedFolder !== currentFolderId) {
      onSelect(selectedFolder);
      onClose();
    }
  };

  // 폴더 아이템 렌더링
  const renderFolderItem = (folder, level = 0) => {
    const isDisabled = folder.id === currentFolderId || folder.id === SYSTEM_FOLDERS.TRASH;
    const isSelected = selectedFolder === folder.id;

    return (
      <div key={folder.id}>
        <div
          className={`folder-select-item ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
          style={{ paddingLeft: `${level * 20 + 16}px` }}
          onClick={() => !isDisabled && setSelectedFolder(folder.id)}
        >
          <div className="folder-icon">
            {renderFolderIcon(folder)}
          </div>
          <span className="folder-name">
            {folder.name}
            {folder.id === currentFolderId && ' (현재 위치)'}
          </span>
          {isSelected && <Check size={16} className="check-icon" />}
        </div>
        {folder.children && folder.children.map(child =>
          renderFolderItem(child, level + 1)
        )}
      </div>
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content folder-select-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>폴더로 이동</h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {noteTitle && (
          <div className="modal-info">
            <p>"{noteTitle}" 메모를 이동할 폴더를 선택하세요</p>
          </div>
        )}

        <div className="folder-select-list">
          {folderTree.map(folder => renderFolderItem(folder))}
        </div>

        <div className="modal-actions">
          <Button variant="secondary" onClick={onClose}>
            취소
          </Button>
          <Button
            variant="primary"
            onClick={handleSelect}
            disabled={!selectedFolder || selectedFolder === currentFolderId}
          >
            이동
          </Button>
        </div>
      </div>
    </div>
  );
}

export default FolderSelectModal;